export default __webpack_public_path__ + "static/media/4.44c8bec7.webp";